import React from 'react';

/**
 * Token component - renders a formatted token for thermal printer (80mm)
 * Expects normalized order object with items, subtotal, discount, total, and token info
 */
const Token = ({ order = {}, branch = {} }) => {
  const shopName = branch?.name || "ICE CREAM WORLD";
  const orderTime = order.createdAt || new Date().toLocaleString();
  const rawTokenNumber = order?.token?.token_no ?? order?.token_number ?? null;
  const tokenNumber = rawTokenNumber != null ? String(rawTokenNumber).padStart(3, '0') : '001';
  const rawOrderNum = order.order_number ?? order.token?.order_number ?? order.token?.order_id ?? order.id;
  const orderNumber = rawOrderNum ? `#: ${String(rawOrderNum).padStart(6, '0')}` : '#: 000';
  const paperLabel = order.paper ? `Paper ${order.paper}` : null;
  
  const items = order.items || [];

  return (
    <div
      className="print-area page-break space-y-1 text-[10px] text-black bg-white p-2"
      style={{ width: '80mm', maxWidth: '100%', paddingTop: 0 }}
    >
      <div className="flex justify-between items-center border-b border-gray-300 pb-2">
        <div className="space-y-1">
          <div className="font-bold tracking-widest text-xs">{shopName}</div>
          <div className="text-[9px] uppercase font-semibold">Pickup Token</div>
          <div className="text-[9px]">
            <div className="flex justify-between gap-4">
              <span>Time:</span>
              <span className="font-medium">{orderTime}</span>
            </div>
            <div className="flex justify-between gap-4">
              <span>Order No:</span>
              <span className="font-medium">{orderNumber}</span>
            </div>
            {paperLabel && (
              <div className="flex justify-between gap-4">
                <span>Paper:</span>
                <span className="font-medium">{paperLabel}</span>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col items-center justify-center border-2 border-black p-1 rounded-lg min-w-[50px]">
          <span className="text-[8px] font-bold uppercase">Token No.</span>
          <span className="text-2xl font-black leading-none">{tokenNumber}</span>
        </div>
      </div>

      <div className=" text-base">
        {items.length === 0 ? (
          <div className="text-center text-gray-500">No items added.</div>
        ) : (
          items.map((item) => (
            <div key={item.id || Math.random()} className="flex justify-between font-semibold text-black">
              <div className="truncate pr-2">{item.name}</div>
              <div className="flex-shrink-0 pe-4">{item.quantity}</div>
            </div>
          ))
        )}
      </div>
      <div className="text-center text-[9px] text-black border-t border-gray-200 pt-1">Thank you!</div>
    </div>
  );
};

export default Token;
